<template>
  <img :src="logoName">
</template>

<script>
  import logoDark from '@/img/bubble-plan-logo-white.png';
  import logoLight from '@/img/bubble-plan-logo-color.png';

  export default {
    computed: {
      logoName() {
        return this.$vuetify.theme.global.current.dark ? logoDark : logoLight;
      },
    },
  };
</script>
